import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { $ } from 'protractor';
import { BehaviorSubject, Observable } from 'rxjs';
import { ILibertyRxLoadInventoryStatus } from '../../interfaces/ILibertyRxLoadInventoryStatus';
import { CancelLoadInventoryFromLibertyRx, GetLibertyRxLoadStatus } from '../../states/inventory/inventory.actions';
import { InventoryState } from '../../states/inventory/inventory.state';
import { PharmacyState } from '../../states/pharmacy/pharmacy.state';

@UntilDestroy()
@Component({
  selector: 'app-pill-loader',
  templateUrl: './pill-loader.component.html',
  styleUrls: ['./pill-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PillLoaderComponent implements OnInit, OnDestroy {
  libertyRxLoadingPollInterval: any;

  header = "Load Inventory From LibertyRX";

  expanded = true;

  loadedPercent = 0;

  inventoryLoadedPercent$: BehaviorSubject<number> = new BehaviorSubject(0);

  @Select(InventoryState.libertyRxLoadInventoryStatus) libertyRxLoadInventoryStatus$: Observable<ILibertyRxLoadInventoryStatus>;
  @Select(InventoryState.libertyRxPolling) libertyRxPolling$: Observable<boolean>;
  @Select(PharmacyState.currentPharmacy) currentPharmacy$: Observable<boolean>;

  private loaderInvokerPageUrl = '/inventory/bulk-add';

  constructor(private router: Router, private cdr: ChangeDetectorRef, private store: Store) {
    this.inventoryLoadedPercent$.next(0);
  }

  startPolling() {
    this.inventoryLoadedPercent$.next(0);
    this.libertyRxLoadingPollInterval = setInterval(() => {
      //TODO: Make this interval a config value?
      this.store.dispatch(new GetLibertyRxLoadStatus());
    }, 5000);
  }

  ngOnInit(): void {
    this.startPolling();

    this.router.events
      .pipe(untilDestroyed(this))
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          if(this.expanded !== (this.loaderInvokerPageUrl === event.url)) {
            this.expanded = this.loaderInvokerPageUrl === event.url;
            this.cdr.detectChanges();
          }
        }
      });

    this.libertyRxLoadInventoryStatus$
      .pipe(untilDestroyed(this))
      .subscribe((status: ILibertyRxLoadInventoryStatus) => {
        this.inventoryLoadedPercent$.next((status?.percentageCompleted) || 0);
      });
  }

  onExpandCollapse(): void {
    event.stopPropagation();
    this.expanded = !this.expanded;
  }

  onCancel(): void {
    this.store.dispatch(new CancelLoadInventoryFromLibertyRx());
  }

  navigateToBulkAdd(): void {
    this.router.navigate(['inventory', 'bulk-add']);
  }

  ngOnDestroy(): void {
    if (this.libertyRxLoadingPollInterval) {
      clearInterval(this.libertyRxLoadingPollInterval);
    }
  }
}
